import React from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import Warehouse from '../Warehouse';
import { Toaster } from 'react-hot-toast';
import { PlaylistAddCheckCircle, PlaylistAddCircle } from '@mui/icons-material';

const WarehousePenerimaan = ({ children }) => {
    const { username } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const split = path.split('/');

    return (
        <Warehouse>
            <Toaster position="top-center" />
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="sub-menu">
                            <ul>
                                <li>
                                    <Link to={`/${username}/warehouse/penerimaan/data`} className={` sub-menu-item ${split[4] === 'data'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <PlaylistAddCircle />
                                        </div>
                                        <span>Data Penerimaan</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/warehouse/penerimaan/validasi`} className={` sub-menu-item ${split[4] === 'validasi'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <PlaylistAddCheckCircle />
                                        </div>
                                        <span>Validasi</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            { children }
        </Warehouse>
    )
}

export default WarehousePenerimaan
